import { render, staticRenderFns } from "./AdminInstitutionDashboard.vue?vue&type=template&id=c6ed0760&scoped=true&"
import script from "./AdminInstitutionDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminInstitutionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminInstitutionDashboard.vue?vue&type=style&index=0&id=c6ed0760&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ed0760",
  null
  
)

export default component.exports